import PropTypes from 'prop-types';

export const treeAdapterPropTypes = PropTypes.shape({
  nodeId: PropTypes.func,
  nodeParentId: PropTypes.func,
  nodeTitle: PropTypes.func,
  renderNodeAddons: PropTypes.func,
});

export const treePluginPropTypes = PropTypes.shape({
  prepareTreeState: PropTypes.func,
  tearDownTreeState: PropTypes.func,
  handleWillAddModels: PropTypes.func,
  handleDidAddModels: PropTypes.func,
  handleWillChangeModels: PropTypes.func,
  handleDidChangeModels: PropTypes.func,
  handleWillRemoveModels: PropTypes.func,
  handleDidRemoveModels: PropTypes.func,
  handleDidUpdateTree: PropTypes.func,
});

export const nodePropType = PropTypes.object;

export const selectionVisualsPropType = PropTypes.oneOf([
  'box',
  'checkbox',
  'radio',
]);

export const nodeIdPropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);

export const selectionPropType = PropTypes.oneOfType([
  nodePropType,
  PropTypes.arrayOf(nodePropType),
]);
